

export const loginAdmin = ({ token, admin }) => {
  localStorage.setItem("admin_token", token);
  localStorage.setItem("admin_user", JSON.stringify(admin));
};

export const getToken = () => {
  return localStorage.getItem("admin_token");
};

export const getAdmin = () => {
  const admin = localStorage.getItem("admin_user");
  return admin ? JSON.parse(admin) : null;
};

export const logoutAdmin = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_user");
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (error) {
    return true;
  }
};

export const isLoggedIn = () => {
  const token = getToken();
  return !!token && !isTokenExpired(token);
};

export const checkTokenValidity = () => {
  const token = getToken();
  if (!token || isTokenExpired(token)) {
    return false;
  }
  return true;
};
